export default {
  packageCard: {
    Subscription: {
      month: '/month',
    },
    BuyNow: 'Buy Now',
    permission: {
      ve: 'Video Production',
      vrec: 'Screen Recording Tool',
      insights: 'Creative Insights',
      gm: 'Playable Production',
      assets: 'Creative Asset Library',
      packbuy: 'Additional Package',
    },
    packageInfo: {
      validity: 'Valid for 1 year',
      download: {
        amount: 'Total {total} items',
      },
      mtgCharge: {
        noChange: '{baseMessage}{br}',
        change: '{baseMessage} playable download & push',
        notes: '(No limit on Mintegral)',
        notesTip:
          'Export items per ad channel, Mintegral exports have no limits.',
      },
      videoCredits: {
        amount: 'Total {totalPoints} points',
      },
    },
    download: {
      tabType: {
        subscription: 'Playable download &{br} push / month',
        normal: 'Playable download &{br} push',
      },
    },
    videoCredits: {
      tabType: {
        subscription: 'Points/month',
        normal: 'Point',
      },
    },
    storage: {
      amount: 'Storage Space',
      space: '{amount}G',
    },
    online: {
      amount: 'Number of Logins',
    },
    grantLabel: {
      hot: 'Popular',
      recommend: 'Recommended',
    },
  },
  selectPackage: {
    title: 'Please choose a suitable package for you',
    tabType: {
      subscription: {
        quarter: 'Subscribe Quarterly',
        annualized: 'Subscribe Annually (Save 20%)',
      },
    },
    tabs: {
      tabType: {
        personal: 'Purchase by Quantity (Individual)',
        enterprise: 'Purchase by Quantity (Enterprise)',
        subscription: 'Subscribe by Duration (Enterprise)',
      },
    },
    contract: {
      dialog: {
        title: 'Purchase Package',
        message:
          'You do not have permission to purchase, please contact us via online inquiry.',
      },
    },
    isEnterprise: {
      dialog: {
        message:
          'You already have a subscription package and cannot purchase it again. You can buy additional package to enhance benefits.',
        confirmbtn: 'Purchase',
      },
    },
  },
  subscription: {
    package: {
      title: 'Purchase Additional Package',
      description:
        '* The subscription package is calculated as 30 days per month. If the package is insufficient, you can buy additional package: Playable Downloads/Pushes: {currency}{pushPrice}/item, Additional Points: {currency}{AddPrice}/5000 points, Storage upgrade to 200GB: {currency}{storagePrice}/month.',
      tooltip: 'After subscribing to the package, you can purchase more.',
      contact: {
        text: 'Need more? Contact us for enterprise custom packages.',
        button: 'Contact Now',
      },
    },
  },
  record: {
    payment: {
      status: {
        pending: 'Pending Payment',
        success: 'Payment Successful',
        failed: 'Payment Failed',
        canceled: 'Canceled',
        warning: 'Payment Confirming',
      },
      statusTip: {
        warning:
          'Third-party payment channels require some time to verify the transaction. Once the payment is confirmed, the system will automatically activate the package authorization or recharge the account balance.',
      },
    },
    grantOrderType: {
      packBuy: 'Purchase Additional Package',
      packageBuy: 'Purchase Package',
      recharge: 'Recharge',
    },
    page: {
      title: 'Purchase History',
      search: {
        preLabel: 'Payment Status',
        placeholder: 'All',
      },
    },
    table: {
      name: 'Name',
      tooltip: {
        downloadPush: 'playable download & push: {download_push} items',
        videoCredits: 'Points: {video_credits}',
      },
      bill: {
        amount: 'Billing Amount',
      },
      operation: 'Operations',
      package: {
        validity: 'Package Expiration Date',
      },
      update: {
        time: 'Update Time',
      },
      payAgain: 'Repay',
    },
    cancelPayment: {
      dialog: {
        title: 'Cancel Order',
        message:
          'Once canceled, this order cannot be paid again. Are you sure to cancel?',
        confirmbtn: 'Confirm',
        tip: 'Cancellation Successful',
      },
    },
  },
  grantDialog: {
    partnerName: 'Customer Name',
    package: {
      info: 'Order information',
      firstTips:
        'After purchasing a individual package, the account cannot be used to purchase a enterprise package.',
      validityDays: 'Expiration Date:',
      amount: 'Recharge Amount:',
    },
    packBuy: {
      info: 'Please select the content and quantity to purchase.',
    },
    desc: 'Any government taxes arising from this cooperation, including but not limited to withholding tax, GST, VAT, etc., shall be borne by you.',
    countTips: 'Please select the quantity to purchase.',
    submit: 'Confirm and Proceed to Payment',
    minAmountTip: 'Minimum Amount ${min_amount}',
    agree: 'Please check the Playturbo Membership Service Agreement.',
    partnerCodeTip: 'Please select the customer name',
    amountTips: 'Please enter the recharge amount',
    recharge: 'Online Recharge',
    packTable: {
      price: 'Unit Price',
      count: 'Quantity',
      storageTips:
        'Your subscription package still has {quantity} months left.',
      amount: 'Price',
      name: 'Name',
      downloadPush: 'Add Playable Download & Push',
      renderVideo: 'Add Points',
      storageUpgrade: 'Storage Upgrade to {storage} G',
    },
    packageTable: {
      days: '{days} days',
    },
    totalFooter: {
      price: 'Price (excluding tax)',
    },
    downloadPushUnit: '{count} items',
    renderVideoUnit: '{count} points',
    storageUnit: '{count} months',
    amountTips2: 'Only numeric input allowed',
  },
  checkGrant: {
    success: 'Payment Successful',
    successMessage:
      'Your payment was successful, the order payment status may have a delay in refreshing, please wait patiently.',
    successConfirm: 'Got it',
    failedMessage: 'Purchase Failed',
  },
  router: {
    title: 'Purchase Package',
  },
  profile: {
    form: {
      usertype: {
        title: 'Account Type',
        personal: 'Individual User',
        organization: 'Enterprise User',
      },
      contactQuestion: 'Want to become a Playturbo Enterprise User?',
      contactUs: 'Contact Us',
    },
  },
}
